import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any, screens: any) => ({
  section: css`
    display: flex;
    justify-content: center;
    padding-inline: ${screens.lg
      ? token.paddingInlineSection
      : token.paddingXSInlineSection};
  `,
  body: css`
    max-width: ${token.maxWidthSection};
    padding-block: ${token.paddingBlockSection};
    width: 100%;
  `,
  secondary: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
}));

export const useSectionPageStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
